<script setup>
import { Link } from '@inertiajs/vue3';
import { ref, onMounted, onUnmounted } from 'vue';
import Nav from '@/Components/Nav.vue';
import Logo from '@/Components/Logo.vue';
import Button from '@/Components/Button.vue';

const isScrolled = ref(false);

const handleScroll = () => {
    isScrolled.value = window.scrollY > 50;
};

onMounted(() => {
    window.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
});
</script>

<template>
    <header
        class="w-full fixed z-50 top-0 text-secondary py-[7px] md:py-0 px-3 md:px-4 xl:px-0 transition-all duration-300"
        :class="isScrolled ? 'bg-white shadow-md' : 'bg-transparent xl:shadow-none'"
    >
        <div class="w-full xl:w-width-layout mx-auto flex justify-between items-center">
            <Link :href="route('home.index')">
                <Logo />
            </Link>
            <Nav />
            <Button class="hidden xl:block" :btnName="'ភ្ជាប់ទំនាក់ទំនងជាមួយគ្នា'" :routeName="'contact.us'"/>
        </div>
    </header>
</template>
